import {Component, OnDestroy, OnInit} from '@angular/core';
import {Fault, ViewFault} from '@docma-mm-core/fault/fault';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {SyncStatusEnum} from '@docma-mm-core/model/sync-state/sync-status.enum';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {FaultStateEnum} from '@docma-mm-core/fault/fault-state.enum';
import {FaultService} from '@docma-mm-core/fault/fault.service';
import {MmFaultsLoaderService} from '../../../mm-faults-loader.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {getOverallStateByFault, getOverallStateBySync, OverallSyncStatus} from '../../../sync-status.util';
import {isGroupNode} from '@mydocma/component-library/src/lib/grid';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-sync.cell-renderer',
  templateUrl: './sync.cell-renderer.component.html',
  styleUrls: ['./sync.cell-renderer.component.scss']
})
export class SyncCellRendererComponent implements ICellRendererAngularComp, OnInit, OnDestroy {

  changeStatus = ChangeStatusEnum;
  loadStatus = LoadStatusEnum;
  syncStatus = SyncStatusEnum;

  faultStates = FaultStateEnum;
  fault: ViewFault;

  private faultStateChanged = new BehaviorSubject<FaultStateEnum>(FaultStateEnum.None);
  public onFaultStateChanged$ = this.faultStateChanged.asObservable();

  constructor(private readonly faultSyncService: FaultSyncService,
              private readonly faultService: FaultService,
              private readonly faultsLoaderService: MmFaultsLoaderService) {
  }

  refresh(params: ICellRendererParams): boolean {
    this.fault = params.data as ViewFault;
    this.setFaultState(this.fault);
    return true;
  }

  setFaultState(changedFault: Fault) {
    if (!isGroupNode(changedFault) && changedFault.uid === this.fault.uid) {
      const overallSyncStatus = getOverallStateByFault(changedFault, this.fault, this.faultService);
      if (overallSyncStatus === OverallSyncStatus.notSynced) {
        this.faultStateChanged.next(FaultStateEnum.InProgress);
      } else if (overallSyncStatus === OverallSyncStatus.syncError) {
        this.faultStateChanged.next(FaultStateEnum.Error);
      } else {
        this.faultStateChanged.next(FaultStateEnum.None);
      }
    }
  }
  agInit(params: ICellRendererParams): void {
    if (!isGroupNode(params?.data) && !!params?.data) {
      this.fault = params.data as ViewFault;
      this.setFaultState(this.fault);

      this.faultSyncService.syncFaultsState$
        .pipe(untilDestroyed(this))
        .subscribe(params => {
          const overallSyncStatus = getOverallStateBySync(params.changes, this.fault);
          if (overallSyncStatus === OverallSyncStatus.notSynced) {
            this.faultStateChanged.next(FaultStateEnum.InProgress);
          }
          else if (overallSyncStatus === OverallSyncStatus.syncError) {
            this.faultStateChanged.next(FaultStateEnum.Error);
          }
          else {
            this.faultStateChanged.next(FaultStateEnum.None);
          }
        });

      this.faultService.onFaultChanged
        .pipe(untilDestroyed(this))
        .subscribe((changedFault: Fault) => {
          this.setFaultState(changedFault);
        });

      this.faultsLoaderService.onFaultChanged
        .pipe(untilDestroyed(this))
        .subscribe((changedFault: Fault) => {
          this.setFaultState(changedFault);
        });
    }
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }
}
